import { render, staticRenderFns } from "./fccAbaVagasReservadas.vue?vue&type=template&id=cdfdce7e"
import script from "./fccAbaVagasReservadas.vue?vue&type=script&lang=js"
export * from "./fccAbaVagasReservadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports